module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8mm3n"))).then(() => module.bundle.root('aVi2q'));